import moment from 'moment-timezone';

export type Timezone = {
	label: string;
	value: {
		zone: string;
		abbv: string;
	};
};

const reformatTimezoneToOption = (zone: string): Timezone => {
	const filteredZone = zone.replace(/\bKiev\b/g, 'Kyiv');
	const formattedZone = filteredZone.replace(/_/g, ' ');
	return {
		label: formattedZone,
		value: {
			abbv: moment.tz(filteredZone).format('z'),
			zone,
		},
	};
};

export const TIMEZONE_OPTIONS: Timezone[] = (moment.tz.names() as string[])
	.filter((zone) => {
		const lowerZone = zone.toLowerCase();
		return !(
			['est', 'mst', 'hst', 'roc'].includes(lowerZone) ||
			// We replace Europe/Kiev with Europe/Kyiv in the UI because backends don't support Europe/Kyiv yet
			lowerZone === 'europe/kyiv' ||
			lowerZone.startsWith('etc/') ||
			lowerZone.startsWith('gmt')
		);
	})
	.map((zone) => reformatTimezoneToOption(zone));

export const getBrowserTimezone = (): Timezone | undefined => {
	const filteredList = TIMEZONE_OPTIONS.filter((option) => option.value.zone === moment.tz.guess());
	if (filteredList.length > 0) return filteredList[0];
	else return undefined;
};

export const timeList = [...Array(24).keys()].flatMap((hour) => [`${hour}:00`, `${hour}:30`]);
